import { ArrowUpRight } from "lucide-react";
import { Reveal, RevealLine } from "../lib/motion";
import { BUSINESS_UNITS, IMG } from "../data";

export const Advisory = ({ onBook }) => (
  <section id="advisory" data-testid="advisory-section" className="py-24 sm:py-32 bg-[var(--anthracite)] text-white">
    <div className="max-w-7xl mx-auto px-6 sm:px-12">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
        <div className="lg:col-span-8">
          <div className="overline mb-6">Business Unit</div>
          <h2 className="font-serif text-4xl sm:text-5xl leading-tight">
            <RevealLine>Executive & Board Advisory</RevealLine>
            <RevealLine delay={0.08} className="italic text-[var(--accent)]">al più alto livello.</RevealLine>
          </h2>
        </div>
        <div className="lg:col-span-4 relative aspect-video overflow-hidden">
          <img src={IMG.boardroom} alt="Boardroom" className="w-full h-full object-cover opacity-80 hover:opacity-100 transition-[opacity] duration-700" />
        </div>
      </div>

      <div className="border-t border-white/15">
        {BUSINESS_UNITS.map((b, i) => (
          <Reveal key={b.n} delay={i * 0.04}>
            <div data-testid={`unit-${b.n}`} className="group grid grid-cols-1 md:grid-cols-12 gap-4 py-8 border-b border-white/15 items-baseline hover:bg-white/[0.04] transition-[background-color] duration-400 px-2">
              <div className="md:col-span-1 font-serif text-2xl text-[var(--accent)]">{b.n}</div>
              <h3 className="md:col-span-4 text-2xl font-medium flex items-center gap-2">
                {b.title}
                <ArrowUpRight size={18} strokeWidth={1.5} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-400" />
              </h3>
              <p className="md:col-span-7 text-white/60 leading-relaxed">{b.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-20 pt-12 border-t border-white/15 grid lg:grid-cols-12 gap-8 items-end">
        <div className="lg:col-span-8">
          <div className="overline !text-white/60 mb-5">Costruiamo insieme</div>
          <h2 className="font-serif text-3xl sm:text-4xl leading-tight">
            <RevealLine>Pronta ad affiancare</RevealLine>
            <RevealLine delay={0.08} className="italic text-[var(--accent)]">il tuo board.</RevealLine>
          </h2>
        </div>
        <div className="lg:col-span-4 lg:text-right">
          <button data-testid="advisory-book-btn" onClick={onBook}
            className="btn-fill inline-flex text-xs font-semibold uppercase tracking-[0.15em] border border-white text-white hover:text-[var(--anthracite)] px-8 py-4"
            style={{ "--accent": "#ffffff" }}>
            Prenota una Executive Call
          </button>
        </div>
      </div>
    </div>
  </section>
);
